/* eslint-disable */
import { BiShoppingBag, BiPencil, BiCodeBlock } from "react-icons/bi";
import { BsCodeSlash, BsClipboardData, BsFileEarmarkCode } from "react-icons/bs";
import { AiOutlineMail, AiFillAudio, AiOutlineQrcode, AiFillGithub } from "react-icons/ai";
import { FaInternetExplorer,  FaChalkboardTeacher, FaCameraRetro, FaPinterest, FaVideo, FaTabletAlt, FaRegNewspaper, FaReact, FaGit, FaGitSquare, FaGitAlt, FaNpm } from "react-icons/fa";
import { IoLogoJavascript, IoLogoNpm } from "react-icons/io";
import { IoLogoFirebase } from "react-icons/io5";

 

export const servicesData = [
    {
        id: 1,
        title: 'Web App. Development',
        icon: <AiOutlineQrcode />
    },
    {
        id: 3,
        title: 'React App. Development',
        icon: <FaReact />
    },
    {
        id: 4,
        title: 'JavaScript',
        icon: <IoLogoJavascript />
    },
    // {
    //     id: 5,
    //     title: 'Tutoring',
    //     icon: <FaChalkboardTeacher />
    // },

    {
        id: 6,
        title: 'Web Design',
        icon: <BsFileEarmarkCode />
    },
    {
        id: 14,
        title: 'Web Development',
        icon: <BsCodeSlash />
    },
    {
        id: 2,
        title: 'Git',
        icon: <FaGitAlt /> 
    },
    {
        id: 7,
        title: 'GitHub',
        icon: <AiFillGithub />
    },
    {
        id: 8,
        title: 'NPM',
        icon: <IoLogoNpm />
    }, 
    {
        id: 9,
        title: 'Firebase',
        icon: <IoLogoFirebase />
    },
    // {
    //     id: 10,
    //     title: 'Data Entry', 
    //     icon: <BsClipboardData />
    // },
    // {
    //     id: 11,
    //     title: 'Ebook Writing',
    //     icon: <FaTabletAlt />
    // },
    // {
    //     id: 12,
    //     title: 'Audio Transcription',
    //     icon: <AiFillAudio />
    // },
    {
        id: 13,
        title: 'Blog Posting',
        icon: <FaRegNewspaper />
    },

]

// Uncomment your required service.
// Couldn't find the required services? Raise an issue on github at https://github.com/hhhrrrttt222111/developer-portfolio/issues/new
// You can also add on your own 😉.